import { helpers } from '../helpers.js';

var header = {
	selectors: { },

	init: function () {
		var self = this;

		self.openCloseMobileNav();
		self.openCloseMobileSubnavs();
		self.openCloseLanguages();
		
	},

	openCloseMobileNav: function() {
		var self = this;

		if( document.querySelectorAll( '.js-toggleHeaderNav' ).length == 0 ) {
			return false;
		}
		
		document.querySelectorAll( '.js-toggleHeaderNav' ).forEach(function( button, item ){
			button.addEventListener( 'click', (e) => {

				document.querySelector( '.header-navigation' ).classList.toggle( 'active' );
				e.preventDefault();
			});
		});
		
	},

	openCloseMobileSubnavs: function() {
		var self = this;


		if( document.querySelectorAll( '.toggle-submenu' ).length == 0 ) {
			return false;
		}
		
		document.querySelectorAll( '.toggle-submenu' ).forEach(function( button, item ){
			button.addEventListener( 'click', (e) => {

				button.classList.toggle( 'active' );
				e.preventDefault();
			});
		});
		
	},

	openCloseLanguages: function() {
		var self = this;

		if( document.querySelectorAll( '.pll-parent-menu-item ' ).length == 0 ) {
			return false;
		}
		
		document.querySelectorAll( '.pll-parent-menu-item ' ).forEach(function( button, item ){
			button.addEventListener( 'click', (e) => {

				button.classList.toggle( 'active' );
				e.preventDefault();
			});
		});
		
	},
};

export { header };